<template>
  <div class="modal fade" id="addGroup" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
     <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Add Group</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="form-label">Group Name</label>
              <div class="input-group">
                  <input v-model="groupForm.groupName" class="form-control" required>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn" @click="TryAddGroup()" data-bs-dismiss="modal" style="background-color: #56759c;color: #ffffff">
                <font-awesome-icon icon="save"/>
                <span class="mx-1">Save</span>
              </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"

    export default {
        name: "AddGroup",
        props: ['isActiveGroupModal', 'projectId'],
        data() {
            return {
              groupForm: {
                    id: 0,
                    groupName: "",
                    projectId: 0

                }
            }
        },
        computed: {
            ...mapState('roles', ['roles']),
        },
        methods: {
            ...mapActions('roles', ['getRolesOfProject', 'addGroup']),

            openCloseRoleModal() {
                this.groupForm.groupName = "";
                this.$emit('openCloseGroupModal');
            },
            async TryAddGroup() {
                try {
                    //this.projectRoleForm.projectId = parseInt(this.projectId);
                    await this.addGroup(this.groupForm);
                    //await this.getRolesOfProject(this.projectRoleForm.projectId);
                    await this.openCloseRoleModal();
                    this.$notify({title: "Success", type: "success", text: "Successfully added role."})
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e})
                }
            },
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    //this.$emit('openCloseRoleModal');
                    this.isActiveGroupModal = false;
                }
            })
        },
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
